import {
  Button,
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography
} from '@material-ui/core';
import React, { useState } from 'react'
import { useParams } from 'react-router'
import { Link } from 'react-router-dom';

import Layout from '../Layout';
import Haamel from './Haamel'
import Jaygahdar from './Jaygahdar'
import MasoolPetroshimi from './MasoolPetroshimi'

const useStyles = makeStyles((theme) => ({

  paper: {
    padding: theme.spacing(2),
  },
  image: {
    height: '80vh',
    background: `url(${process.env.PUBLIC_URL}'/ZeroJourneyer/Dr.Rastaranj.png')`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom',
  },
}))


const Index = () => {
  const classes = useStyles();
  const { type } = useParams();

  return (
    <Layout appbarMode='SARPARAST'>
      <Grid
        container item
        justifyContent='center'
        alignItems='center'
        xs={12} sm={8} md={6}>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Grid item container>
              <Grid
                container
                item
                direction='column'
                justifyContent='center'
                spacing={2}>
                <Grid item>
                  <Typography gutterBottom variant='h2' align='center'>{'افزودن جزئیات'}</Typography>
                </Grid>
                {
                  type == 'PETROL_SUPERVISOR' &&
                  <MasoolPetroshimi />
                }
                {
                  type == 'COURIER' &&
                  <Haamel />
                }
                {
                  type == 'STATION_HOLDER' &&
                  <Jaygahdar />
                }
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Layout>
  )
}

export default (Index);